import { capitalCategoricalPalette } from "../../capitalCategoricalPalette.js";
const MuiChartsDataProvider = {
  defaultProps: {
    colors: capitalCategoricalPalette
  }
};
export {
  MuiChartsDataProvider
};
//# sourceMappingURL=MuiChartsDataProvider.js.map
